import { I18n } from '@calendly/i18n'
import { Avatar } from '@calendly/ui/components/avatar'
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy'
import { BodyText } from '@calendly/ui/components/typography'
import { colorTextSecondary } from '@calendly/ui/theme'

import { getInitials } from 'shared/utils'

import CancelledIcon from '../cancel.svg'
import ConfirmedIcon from '../confirmed.svg'
import RescheduledIcon from '../reschedule.svg'
import {
  AvatarContainer,
  Container,
  NameString,
  Wrapper,
  wrapperVerticalPaddingOnlyCss,
  avatarContainerFixedSizeCss,
  NameContainer, AvatarIcon
} from '../styles'

/**
 * Minimal row for displaying a guest (e.g. additional guest email on a solo event).
 * No CRM lookup, dropdown, expand, or actions.
 * Vertical spacing vs the primary attendee and other guests comes from the parent
 * (e.g. soloInviteeGuestStackCss flex gap in CalendlyInviteesContent / SoloEvent).
 */
export const GuestRow = ({ email, name, isConfirmed, isCancelled, isRescheduled }) => {
  const displayName = name || email

  return (
    <Wrapper className={wrapperVerticalPaddingOnlyCss} data-testid={`guest-row-${email}`}>
      <Container noBottomMargin>
        <AvatarContainer className={avatarContainerFixedSizeCss}>
          <Avatar
            letter={getInitials(displayName)}
            alt={displayName}
            aria-label={displayName}
            size="small"
          />
          {isCancelled && <AvatarIcon src={CancelledIcon} />}
          {isRescheduled && <AvatarIcon src={RescheduledIcon} />}
          {isConfirmed && <AvatarIcon src={ConfirmedIcon} />}
        </AvatarContainer>
        <NameContainer>
          <NameString>
            <FullStoryMask>{displayName}</FullStoryMask>
          </NameString>
          <BodyText size="x-small" color={colorTextSecondary}>{I18n.t('publisher.meetings.invitees.guest_label')}</BodyText>
        </NameContainer>
      </Container>
    </Wrapper>
  )
}
